import React from 'react';

import { Search } from 'lucide-react';
import { components, DropdownIndicatorProps } from 'react-select';

export const SearchDropdownIndicator = (props: DropdownIndicatorProps<any>) => {
  return (
    <components.DropdownIndicator {...props}>
      <Search color="#64748B" size={20} strokeWidth={3} />
    </components.DropdownIndicator>
  );
};
